import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "native-base";
import { useTranslation } from "@madmedical/i18n";
import ListHeader from "../../molecules/ListHeader";
const Charts = ({ charts }) => {
    const { t } = useTranslation();
    return (_jsxs(_Fragment, { children: [_jsx(ListHeader, { title: t("measures:title"), borderBottomWidth: 0, px: 0 }), _jsx(Box, Object.assign({ mb: 3, width: "100%" }, { children: charts }))] }));
};
export default Charts;
